import './PricingPage.css';

import React from 'react';

import { useNavigate } from 'react-router-dom';
import { usePostHog } from '@posthog/react';

import MarketingFooter
  from '../components/common/MarketingFooter/MarketingFooter';
import MarketingTopNav
  from '../components/common/MarketingTopNav/MarketingTopNav';
import PomPom from '../components/common/PomPom/PomPom';

const included = [
  'Customizable tryout forms',
  'Unlimited photos, skills, and comments per athlete',
  '5 videos per athlete',
  'Live scoring across your whole staff',
  'Athlete quick-select bar',
  'Real-time ranking & team placement',
  'No app download — join from any phone browser',
];

const PricingPage: React.FC = () => {
  const navigate = useNavigate();
  const posthog = usePostHog();

  return (
    <div className="pp-container">
      <MarketingTopNav />

      <div className="pp-gutter-pompoms" aria-hidden="true">
        <PomPom size="xlarge" color="pink"  className="pp-gutter-pompom pp-gutter-right-top" />
        <PomPom size="large"  color="teal"  className="pp-gutter-pompom pp-gutter-left-mid" />
        <PomPom size="xlarge" color="teal"  className="pp-gutter-pompom pp-gutter-right-bottom" />
        <PomPom size="medium" color="pink"  className="pp-gutter-pompom pp-gutter-left-bottom" />
      </div>

      <div className="pp-maxwidth">
        {/* Hero */}
        <section className="pp-hero">
          <PomPom size="large"  color="pink" className="pp-hero-pompom pp-hero-pompom-tr" />
          <PomPom size="medium" color="teal" className="pp-hero-pompom pp-hero-pompom-bl" />
          <div className="pp-hero-inner">
            <h1 className="pp-hero-title">
              Simple<br />
              <span className="pp-hero-accent">pricing</span>
            </h1>
            <p className="pp-hero-sub">
              One plan, everything included.
            </p>
          </div>
        </section>

        {/* Price card */}
        <section className="pp-price-section">
          <div className="pp-price-card">
            <div className="pp-price-badge">All-inclusive</div>

            <div className="pp-price-row">
              <span className="pp-price-dollar">$</span>
              <span className="pp-price-amount">3</span>
              <div className="pp-price-unit">
                <span className="pp-price-per">per</span>
                <span className="pp-price-label">athlete</span>
              </div>
            </div>

            <p className="pp-price-note">
              No subscription, no per-coach fees.
            </p>

            <ul className="pp-included-list">
              {included.map((item) => (
                <li key={item} className="pp-included-item">
                  <span className="pp-check" aria-hidden="true">✓</span>
                  {item}
                </li>
              ))}
            </ul>

            {/* <button className="pp-btn-primary" onClick={() => navigate('/login')}>
              Get Started
            </button> */}
            {/* <p className="pp-card-footnote">
              Free to set up. You're only charged when your tryout is live.
            </p> */}
          </div>
        </section>

        {/* FAQ strip */}
        {/* <section className="pp-faq">
          <h2 className="pp-faq-title">Common questions</h2>

          {[
            {
              q: 'When am I charged?',
              a: 'When you launch a tryout. You set your athlete count, pay once, and you\'re ready to go.',
            },
            {
              q: 'How many coaches can score?',
              a: 'Unlimited. Every scoring coach joins for free — only the admin account pays.',
            },
            {
              q: 'What if I add athletes mid-tryout?',
              a: 'You can add athletes anytime. Extra athletes are billed at the same $3 rate.',
            },
            {
              q: 'Is there a free trial?',
              a: 'Yes. You can create your form, add athletes, and explore everything before paying.',
            },
          ].map((faq) => (
            <div key={faq.q} className="pp-faq-item">
              <h3 className="pp-faq-q">{faq.q}</h3>
              <p className="pp-faq-a">{faq.a}</p>
            </div>
          ))}
        </section> */}

        {/* CTA */}
        <section className="pp-cta">
          <h2 className="pp-cta-title">
            Ready to run your<br />
            <span className="pp-cta-accent">best tryout?</span>
          </h2>
          <div className="pp-cta-buttons">
            <button className="pp-btn-primary" onClick={() => { posthog?.capture('get_started_clicked', { source: 'pricing_page' }); navigate('/createaccount'); }}>
              Get Started
            </button>
            <button className="pp-btn-ghost" onClick={() => { posthog?.capture('demo_clicked', { source: 'pricing_page' }); navigate('/demo'); }}>
              See a Demo →
            </button>
          </div>
        </section>

        <MarketingFooter />
      </div>
    </div>
  );
};

export default PricingPage;
